export default "__VITE_ASSET__DJO8Wvc9__"